module.exports = __webpack_public_path__ + "static/media/Avatar.ed9bac89.png";